import React from 'react';
import { motion } from 'framer-motion';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  return (
    <div className="not-found-page">
      <div className="background-gradient">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="not-found-content">
        <motion.div
          className="not-found-text"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <h1>404</h1>
          <h2>페이지를 찾을 수 없어요</h2>
          <p>요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.</p>
          
          <div className="not-found-actions">
            <motion.a
              href="/"
              className="btn btn-primary glass-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              홈으로 돌아가기
            </motion.a>
            <motion.a
              href="https://discord.gg/cheese2024"
              className="btn btn-secondary glass-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Discord 참여하기
            </motion.a>
          </div>
        </motion.div>

        <motion.div
          className="not-found-visual"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="broken-icon">
            <img src="/assets/broken.png" alt="페이지를 찾을 수 없습니다" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;